import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import AdvantagesSection from "../containers/AdvantagesSection";
import HusqvarnaAdvantagesSection from "../containers/HusqvarnaAdvantagesSection";
import Footer from "../containers/Footer";
import CirclePresentation from "../containers/CirclePresentation";
import AppWrapper from "../containers/AppWrapper";

class Circle extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />

        <CirclePresentation
          circleId={this.props.match.params.circleId}
          circleCollection={this.props.match.params.circleCollection}
        />

        {this.props.match.params.circleCollection === "husqvarna" ? (
          <HusqvarnaAdvantagesSection />
        ) : (
          <AdvantagesSection />
        )}

        <Footer />
      </AppWrapper>
    );
  }
}

export default Circle;
